"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _shimmer = _interopRequireDefault(require("./shimmer.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SHIMMER_SECOND_COLOR = '#ECEDEF';

var ShimmerContainer = _styledComponents.default.div.withConfig({
  displayName: "Shimmer__ShimmerContainer",
  componentId: "sc-mctpph-0"
})(["width:", ";height:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var ShimmerLoader = _styledComponents.default.span.withConfig({
  displayName: "Shimmer__ShimmerLoader",
  componentId: "sc-mctpph-1"
})(["display:block;height:100%;", " border-radius:", ";background-size:200%;background-position:0 0;", ""], function (props) {
  return !props.colorAnimation && (0, _styledComponents.css)(["background:linear-gradient( to right,", ",", ",", ",", ",", " );"], props.theme.colors.greyLight, SHIMMER_SECOND_COLOR, props.theme.colors.greyLight, SHIMMER_SECOND_COLOR, props.theme.colors.greyLight);
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.colorAnimation ? (0, _styledComponents.css)(["animation:colorLoad 1s linear infinite alternate;@keyframes colorLoad{0%{background-color:#F0F2F6}100%{background-color:#d8d9dd}"]) : "\n        animation: load 1s linear 3s infinite normal both;\n        @keyframes load {\n          from {\n            background-position: 100% 0;\n          }\n\n          to {\n            background-position: 0 0;\n          }\n        }\n      ";
});

var Shimmer = function Shimmer(props) {
  var width = props.width,
      height = props.height,
      borderRadius = props.borderRadius,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      colorAnimation = props.colorAnimation;
  var tabIndex = !accessible ? '-1' : '0';
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ShimmerContainer, (0, _extends2.default)({
    width: width,
    height: height,
    tabIndex: tabIndex
  }, customProperties), /*#__PURE__*/_react.default.createElement(ShimmerLoader, {
    borderRadius: borderRadius,
    colorAnimation: colorAnimation
  })));
};

Shimmer.propTypes = _shimmer.default.PropTypes;
Shimmer.defaultProps = _shimmer.default.DefaultProps;
var _default = Shimmer;
exports.default = _default;